/**
 * 5.0.6 Profile - Enterprise Admin - Network
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=2507%3A7294
 */
// @react
import React from 'react'
// @design
import { makeStyles } from '@material-ui/core/styles'
import Container from '@bit/atd.web.container'
// @components
import ForumMembership from './ForumMembership'
import GroupPortal from './GroupPortal'
import LearningCredits from './LearningCredits'
// @module Components

const useStyles = makeStyles({
  root: {},
})

const EnterpriseAdminTabs = () => {
  /******************************************
   * HOOKS
   ******************************************/
  const classes = useStyles()

  /******************************************
   * FUNCTIONS
   ******************************************/

  /**
   * props
   */
  return (
    <div className={classes.root}>
      <ul>
        <li>Forum membership tab CTA</li>
        <li>Group membership tab CTA</li>
        <li>learning credits tab CTA</li>
      </ul>

      <Container>
        <ForumMembership />
        <GroupPortal />
        <LearningCredits />
      </Container>
    </div>
  )
}

export default EnterpriseAdminTabs
